/**
 * Download an array of objects as a CSV file.
 *
 * @param {Array<string>}   headers   - Column header labels
 * @param {Array<Array>}    rows      - Each row is an array of cell values
 * @param {string}          filename  - Downloaded filename (e.g. "purchase-log.csv")
 *
 * Usage:
 *   exportCSV(
 *     ['Date', 'Bill No', 'Total'],
 *     rows.map(r => [r.date, r.bill_number, r.total_amount]),
 *     'purchase-log.csv'
 *   );
 */
export const exportCSV = (headers, rows, filename) => {
  const escape = (val) => {
    if (val === null || val === undefined) return '';
    const str = String(val);
    return str.includes(',') || str.includes('"') || str.includes('\n')
      ? `"${str.replace(/"/g, '""')}"`
      : str;
  };

  const lines = [
    headers.map(escape).join(','),
    ...rows.map(row => row.map(escape).join(',')),
  ];

  const blob = new Blob([lines.join('\n')], { type: 'text/csv;charset=utf-8;' });
  const url  = URL.createObjectURL(blob);
  const a    = document.createElement('a');
  a.href     = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
};
